var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.061,
    height: 23.826,
    viewBox: "133 84.174 19.061 23.826",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.167 105.022c.494 0 .894-.4.894-.894V86.854a2.684 2.684 0 0 0-2.68-2.68h-13.7a2.684 2.684 0 0 0-2.681 2.68v18.466a2.684 2.684 0 0 0 2.68 2.68h15.487a.893.893 0 1 0 0-1.787H135.68a.895.895 0 0 1-.893-.893v-.298h16.38ZM138.66 90.13h7.743a.893.893 0 1 1 0 1.787h-7.743a.893.893 0 1 1 0-1.787Z",
    fill: "#8c919a",
    fillRule: "evenodd",
    "data-name": "icons8-book"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.f0396ef3604b16e4e30dc838f49405a2.svg";
export { ForwardRef as ReactComponent };